var map = {
	"./App.js": 42212,
	"./DBConfig.js": 19494,
	"./api/anthempress.js": 61415,
	"./api/api.js": 68931,
	"./api/config.js": 66957,
	"./api/content-novareader-test.js": 68427,
	"./api/content-novareader.js": 49526,
	"./api/ijohs.js": 40522,
	"./api/koganpage.js": 34061,
	"./api/lpp.js": 30051,
	"./api/mybareacts.js": 82906,
	"./api/new/Login.js": 20275,
	"./api/new/Register.js": 32277,
	"./api/researchpad.js": 67254,
	"./api/vijaynicole.js": 12931,
	"./asset/Constants.js": 16182,
	"./backends/pdfjs.js": 17285,
	"./component/Empty.js": 69021,
	"./component/PDFViewer/PDFViewer.js": 15999,
	"./component/PageNotFound.js": 58698,
	"./component/Swaip.js": 80548,
	"./component/dashboard/colllist_Card.js": 30302,
	"./component/dashboard/downloaded_Card.js": 93639,
	"./component/dashboard/header.js": 28614,
	"./component/dashboard/list_Card.js": 77164,
	"./component/dashboard/ratecard.js": 620,
	"./component/dashboard/space.js": 88137,
	"./component/dashboard/subject_Card.js": 8364,
	"./component/dashboard/userCard.js": 77350,
	"./component/dashboard/welcome_Card.js": 80464,
	"./component/pageheader/pageHeader.js": 99525,
	"./component/skeleton/shimmer.js": 3029,
	"./component/skeleton/skeletonbook.js": 67182,
	"./component/skeleton/skeletonelament.js": 55555,
	"./datastore/APIEndpoints.js": 98486,
	"./datastore/APIProxy.js": 72448,
	"./datastore/Utility.js": 66651,
	"./datastore/opendatabase.js": 26457,
	"./index.js": 72812,
	"./modules/EpubView/EpubView.js": 41940,
	"./modules/EpubView/style.js": 4421,
	"./modules/ReactReader/ReactReader.js": 51862,
	"./modules/ReactReader/style.js": 54908,
	"./modules/index.js": 79026,
	"./page/Components.js": 64304,
	"./page/Reader.js": 33913,
	"./page/book&journallist/book_journals_List.js": 58300,
	"./page/book/bookbycollection.js": 42728,
	"./page/book/booksbycategory.js": 75265,
	"./page/book/booksbysubject.js": 55589,
	"./page/dashboard/Institution.js": 91132,
	"./page/dashboard/Institutionshome.js": 26850,
	"./page/dashboard/allcollection.js": 39774,
	"./page/dashboard/collectios.js": 18474,
	"./page/dashboard/dashboard.js": 80821,
	"./page/dashboard/dashboard_old.js": 3255,
	"./page/dashboard/home.js": 75885,
	"./page/description/des.js": 24416,
	"./page/description/description.js": 36830,
	"./page/description/journal.js": 55152,
	"./page/description/newdescription.js": 89323,
	"./page/error/500.js": 10716,
	"./page/error/offline.js": 48244,
	"./page/home/home.js": 19039,
	"./page/library/Favorite.js": 31979,
	"./page/library/downloaded.js": 57501,
	"./page/library/downloadedpage.js": 34906,
	"./page/library/library.js": 21501,
	"./page/library/subscription.js": 15853,
	"./page/login/LoginScreen.js": 32100,
	"./page/login/NormalForgotPasswordForm.js": 61969,
	"./page/login/NormalLoginForm.js": 58330,
	"./page/login/NormalSiginForm.js": 79941,
	"./page/login/UserSessionsModal.js": 33847,
	"./page/login/instLoginForm.js": 73043,
	"./page/login/resetpassword.js": 61982,
	"./page/new/home.js": 46524,
	"./page/offline.js": 54769,
	"./page/pdf/pdf.js": 78993,
	"./page/search/search.js": 96401,
	"./page/setting/account.js": 79646,
	"./redux/actions/dashboardActions.js": 6110,
	"./redux/contants/actions-type.js": 11360,
	"./redux/reducers/dashboardReducers.js": 42422,
	"./redux/reducers/index.js": 31863,
	"./redux/store.js": 21817
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74673;